import { useDispatch, useSelector } from "react-redux";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import axiosInstance from "../config/Axios";
import { useInfiniteQuery, useMutation, useQueryClient } from "react-query";
// import { setIsAdsOn } from "../redux/Slices/layoutSlice";
import { handleResErrors, useInvalidateCampaignLayer } from "./utils";
import { Navigate, useNavigate } from "react-router-dom";
import { toggleDialog } from "../redux/Slices/Global/globalSlice";

//--------------------------Turn Ads on--------------------------
const updateLayoutAdsSettings = async (payload) => {
    const { data } = await axiosInstance.post(`/layout/${payload.id}/enable-ads`);
    return data.data;
}

export const useUpdateLayoutAdsSettingsMutation = () => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);
    const queryClient = useQueryClient();
    const animated = window.location.pathname.includes("animated")
        ? "animated"
        : "normal";
    return useMutation(updateLayoutAdsSettings, {
        onSuccess: () => {
            // dispatch(setIsAdsOn(true));
            queryClient.invalidateQueries(["layoutData"], selectedLayout?.id);
            queryClient.invalidateQueries(["screensData"], selectedLayout?.id);
            queryClient.invalidateQueries({ queryKey: [`allLayout-${animated}`] });


        },
        onError: (error) => handleResErrors(error, showToast)

    })
}


//--------------------------Update ads settings --------------------------
const updateAdsDuration = async (payload) => {
    const { data } = await axiosInstance.post(`/layout/${payload.id}/edit/ads-settings`, payload?.data);
    return data.data;
}

export const useUpdateAdsDuration = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);
    const animated = window.location.pathname.includes("animated")
        ? "animated"
        : "normal";
    return useMutation(updateAdsDuration, {
        onSuccess: async (result, variables) => {
            queryClient.invalidateQueries(["layoutData"], selectedLayout?.id);
            queryClient.invalidateQueries(["screensData"], selectedLayout?.id);
            queryClient.invalidateQueries({ queryKey: [`allLayout-${animated}`] });

            showToast('success', 'Ads Settings', result?.msg);
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------screen ads settings --------------------------
const screenAds = async (payload) => {
    const { data } = await axiosInstance.post(`/layout/ads-on/${payload.id}/screen`, payload?.data);
    return data.data;
}

export const useScreenAds = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);
    const animated = window.location.pathname.includes("animated")
        ? "animated"
        : "normal";
    return useMutation(screenAds, {
        onSuccess: async (result, variables) => {
            queryClient.invalidateQueries(["layoutData"], selectedLayout?.id);
            queryClient.invalidateQueries(["screensData"], selectedLayout?.id);
            queryClient.invalidateQueries({ queryKey: [`allLayout-${animated}`] });

            showToast('success', 'Ads Settings', result?.msg);
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}


//--------------------------screen animation settings --------------------------
const screenAnimation = async (payload) => {
    const { data } = await axiosInstance.post(`/layout/animation-on/${payload.id}/screen`, payload?.data);
    return data.data;
}

export const useScreenAnimation = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);
    const animated = window.location.pathname.includes("animated")
        ? "animated"
        : "normal";

    return useMutation(screenAnimation, {
        onSuccess: async (result, variables) => {
            queryClient.invalidateQueries(["layoutData"], selectedLayout?.id);
            queryClient.invalidateQueries(["screensData"], selectedLayout?.id);
            queryClient.invalidateQueries({ queryKey: [`allLayout-${animated}`] });

            showToast('success', 'Ads Settings', result?.msg);
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------screen animation off --------------------------
const screenAnimationOff = async (payload) => {
    const { data } = await axiosInstance.post(`/layout/animation-off/${payload.id}/screen`, payload);
    return data.data;
}

export const useScreenAnimationOff = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);

    return useMutation(screenAnimationOff, {
        onSuccess: async (result, variables) => {
            queryClient.invalidateQueries(["layoutData"], selectedLayout?.id);
            queryClient.invalidateQueries(["screensData"], selectedLayout?.id);
            showToast('success', 'Ads Settings', result?.msg);
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------screen animation settings --------------------------
const editScreenAnimation = async (payload) => {
    const { data } = await axiosInstance.post(`/layout/edit-animation/${payload.id}/screen`, payload?.data);
    return data.data;
}

export const useEditScreenAnimation = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);

    return useMutation(editScreenAnimation, {
        onSuccess: async (result, variables) => {
            queryClient.invalidateQueries(["layoutData"], selectedLayout?.id);
            queryClient.invalidateQueries(["screensData"], selectedLayout?.id);
            showToast('success', 'Ads Settings', result?.msg);
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}


//--------------------------create animation layout --------------------------
const createLayoutAnimation = async (payload) => {
    const { data } = await axiosInstance.post(`/animated-layout/create`, payload?.data);
    return data.data;
}

export const useCreateLayoutAnimation = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const selectedLayout = useSelector((state) => state.layout.selectedLayout);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const animated = window.location.pathname.includes("animated")
        ? "animated"
        : "normal";
    return useMutation(createLayoutAnimation, {
        onSuccess: async (result) => {
            dispatch(toggleDialog("CreateAnimationLayout"));
            navigate(`/apps/animated_layouts/${result.layoutId}/show`);
            queryClient.invalidateQueries({ queryKey: [`allLayout-${animated}`] });

            showToast("success", "Layout Creation", "Animated Layout created successfully!");
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}
 

// -------------------------- Get all layouts --------------------------
const getAllLayouts = async ({ pageParam = 1, queryKey }) => {
    const [key, { per_page, search }] = queryKey;
    const isAnimated = key.includes("animated"); // derive from key

    const { data } = await axiosInstance.get(
        `/company/layouts${isAnimated ? "/animated" : ""}`,
        {
            params: {
                page: pageParam,
                per_page,
                ...(search ? { search } : {}) // avoid empty string
            }
        }
    );

    return {
        items: data.data,
        currentPage: data.pagination.current_page,
        totalItems: data.pagination.total,
        totalPages: data.pagination.total_pages
    };
};

export const useGetAllLayouts = ({ per_page = 10, search = "" } = {}) => {
    const { showToast } = useCustomToast();
    const animated = window.location.pathname.includes("animated")
        ? "animated"
        : "normal";

    return useInfiniteQuery(
        // put animated in the key to separate caches
        [`allLayout-${animated}`, { per_page, search }],
        getAllLayouts,
        {
            initialPageParam: 1,
            staleTime: 1000 * 60 * 5,
            // keepPreviousData: not needed for infinite queries

            getNextPageParam: (lastPage) =>
                lastPage.currentPage < lastPage.totalPages
                    ? lastPage.currentPage + 1
                    : undefined,

            onSuccess: () => {
                // optional
            },
            onError: (err) => {
                // optionally surface: showToast({ severity: "error", summary: "Failed to load layouts" });
                console.error(err);
            }
        }
    );
};
